const readSessionJson = (key) => {
  if (typeof sessionStorage === 'undefined') {
    return {}
  }

  const value = sessionStorage.getItem(key)
  if (!value || value === 'undefined') {
    return {}
  }

  try {
    return JSON.parse(value) || {}
  } catch {
    return {}
  }
}

export default readSessionJson('account')
export const teamInfo = readSessionJson('teamInfo')
export const getTeamInfo = () => readSessionJson('teamInfo')
export const getUserInfo = () => readSessionJson('account')
